import { STOModel } from "src/models/base/sto-model";
import { DocumentTemplateWithValuesDTO } from "../../models/document-templates/document-template-version/document-template-with-values";
import { WordTemplatePlaceholdersFilter } from "../../models/document-templates/word-template-placeholders-filter";
import { BaseApiService } from "../base/base-api.service";

export class WordTemplateApiService extends BaseApiService<DocumentTemplateWithValuesDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/WordTemplate",
      loadItemsPath: "/FillTemplates",
      //   saveItemsPath: "/SaveFillTemplates",
    });
  }
}

export const fillTemplates = async (
  propsFilter: WordTemplatePlaceholdersFilter,
  signal: AbortSignal | undefined = undefined
) => {
  const service = new WordTemplateApiService();
  const response = await service.loadItems(
    propsFilter,
    undefined,
    undefined,
    {
      pageNumber: 0,
      pageSize: 100,
    },
    false,
    60,
    signal
  );

  return response;
};
